import { takeEvery, put } from "redux-saga/effects";
import { request } from "../../../api/Service";
import { getErrorMessage } from "../../../components/utils/errorHandler";
import { toast } from "react-toastify";

export default function* watcherGetPickUpStationSaga() {
  yield takeEvery("LOAD_PICKUPSTATION", workerSaga);
}

function* workerSaga(action) {
  try {
    yield put({ type: "DISPLAY_LOADER", payload: payload });
    var payload = {};
    var formatUrl = "api/Admin/get-pickup-stations";
    yield request("get", action.payload, formatUrl).then((response) => {
      payload = response;
      console.log("this are the pick-ups", payload);
    });
    yield put({ type: "PICKUPSTATION_LIST", payload: payload });
    yield request("get", payload, "api/Admin/get-countries-dropdown").then(
      (response) => {
        payload = response;
      }
    );
    yield put({ type: "COUNTRIES_DROPDOWN", payload: payload });

    yield request("get", payload, "/api/Admin/get-states").then((response) => {
      payload = response;
    });
    yield put({ type: "STATE_DROPDOWN", payload: payload });

    yield request("get", payload, "/api/Admin/get-cities").then((response) => {
      payload = response;
    });
    yield put({ type: "CITIES_DROPDOWN", payload: payload });

    yield put({ type: "DISPLAY_LOADER", payload: payload });
  } catch (e) {
    console.log(e);
    console.log("pick-up-station-saga", e);
    console.log("pick-up-station-saga", e.response);
    yield put({ type: "LOADING_BUTTON_SPINNER" });
    const errorMessage = getErrorMessage(e.response);
    toast.error(errorMessage);
    yield put({ type: "API_ERRORED", payload: e });
    yield put({ type: "DISPLAY_LOADER", payload: payload });
  }
}
